export const DEFAULT_BANNER_TYPE_QUESTION_TYPES = new Set([
  'acknowledgement',
  'acknowledgment',
  'text_message',
  'warning',
  'info',
  'error',
  'information',
]);

export const DEFAULT_TEXT_QUESTION_TYPES = new Set([
  'text',
  'integer',
  'decimal',
  'email',
  'phone',
  'url',
]);

export const TextInputTypeMapper = new Map<
  string,
  'number' | 'text' | 'password'
>([
  ['integer', 'number'],
  ['decimal', 'number'],
  ['text', 'text'],
  ['email', 'text'],
  ['phone', 'text'],
  ['url', 'text'],
]);

export const STATE_TITLES = new Set<string>([
  'state/province:',
  'province',
  'state',
  'state/province',
  'states'
]);
